import { matchPath } from 'react-router-dom';

export type RouteSeoRule = {
  pattern: string;
  end?: boolean;
  titleKey: string;
  descKey: string;
  /** `<meta name="keywords">`，逗号分隔关键词 */
  keywordsKey: string;
  /** 为 true 时 titleKey 即为完整 document.title（用于首页） */
  fullTitle?: boolean;
};

/**
 * 自上而下首个匹配生效；未命中任何规则时使用 404 文案。
 * 子路径需写在父路径之前（如 /products/cex 在 /products 前）。
 */
export const ROUTE_SEO_RULES: RouteSeoRule[] = [
  {
    pattern: '/',
    end: true,
    titleKey: 'seo.home.title',
    descKey: 'seo.home.desc',
    keywordsKey: 'seo.home.keywords',
    fullTitle: true,
  },
  { pattern: '/about', end: true, titleKey: 'seo.about.title', descKey: 'seo.about.desc', keywordsKey: 'seo.about.keywords' },
  {
    pattern: '/advantages',
    end: true,
    titleKey: 'seo.advantages.title',
    descKey: 'seo.advantages.desc',
    keywordsKey: 'seo.advantages.keywords',
  },
  {
    pattern: '/products/cex',
    end: true,
    titleKey: 'seo.products.cex.title',
    descKey: 'seo.products.cex.desc',
    keywordsKey: 'seo.products.cex.keywords',
  },
  {
    pattern: '/products/rwa',
    end: true,
    titleKey: 'seo.products.rwa.title',
    descKey: 'seo.products.rwa.desc',
    keywordsKey: 'seo.products.rwa.keywords',
  },
  {
    pattern: '/products/wallet',
    end: true,
    titleKey: 'seo.products.wallet.title',
    descKey: 'seo.products.wallet.desc',
    keywordsKey: 'seo.products.wallet.keywords',
  },
  {
    pattern: '/products/defi',
    end: true,
    titleKey: 'seo.products.defi.title',
    descKey: 'seo.products.defi.desc',
    keywordsKey: 'seo.products.defi.keywords',
  },
  {
    pattern: '/products/staking',
    end: true,
    titleKey: 'seo.products.defi.title',
    descKey: 'seo.products.defi.desc',
    keywordsKey: 'seo.products.defi.keywords',
  },
  {
    pattern: '/products/mining',
    end: true,
    titleKey: 'seo.products.mining.title',
    descKey: 'seo.products.mining.desc',
    keywordsKey: 'seo.products.mining.keywords',
  },
  {
    pattern: '/products',
    end: true,
    titleKey: 'seo.products.title',
    descKey: 'seo.products.desc',
    keywordsKey: 'seo.products.keywords',
  },
  {
    pattern: '/services/overseas-fund-setup',
    end: true,
    titleKey: 'seo.services.overseas-fund-setup.title',
    descKey: 'seo.services.overseas-fund-setup.desc',
    keywordsKey: 'seo.services.overseas-fund-setup.keywords',
  },
  {
    pattern: '/services/financial-licensing',
    end: true,
    titleKey: 'seo.services.financial-licensing.title',
    descKey: 'seo.services.financial-licensing.desc',
    keywordsKey: 'seo.services.financial-licensing.keywords',
  },
  {
    pattern: '/services/overseas-company',
    end: true,
    titleKey: 'seo.services.overseas-company.title',
    descKey: 'seo.services.overseas-company.desc',
    keywordsKey: 'seo.services.overseas-company.keywords',
  },
  {
    pattern: '/services/mergers-acquisitions',
    end: true,
    titleKey: 'seo.services.mergers-acquisitions.title',
    descKey: 'seo.services.mergers-acquisitions.desc',
    keywordsKey: 'seo.services.mergers-acquisitions.keywords',
  },
  {
    pattern: '/services',
    end: true,
    titleKey: 'seo.services.title',
    descKey: 'seo.services.desc',
    keywordsKey: 'seo.services.keywords',
  },
  {
    pattern: '/news/:id',
    end: true,
    titleKey: 'seo.newsDetail.title',
    descKey: 'seo.newsDetail.desc',
    keywordsKey: 'seo.newsDetail.keywords',
  },
  { pattern: '/news', end: true, titleKey: 'seo.news.title', descKey: 'seo.news.desc', keywordsKey: 'seo.news.keywords' },
  {
    pattern: '/contact',
    end: true,
    titleKey: 'seo.contact.title',
    descKey: 'seo.contact.desc',
    keywordsKey: 'seo.contact.keywords',
  },
];

const NOT_FOUND_RULE: RouteSeoRule = {
  pattern: '*',
  end: false,
  titleKey: 'seo.notFound.title',
  descKey: 'seo.notFound.desc',
  keywordsKey: 'seo.notFound.keywords',
};

export function matchRouteSeoRule(pathname: string): RouteSeoRule {
  for (const rule of ROUTE_SEO_RULES) {
    const hit = matchPath({ path: rule.pattern, end: rule.end ?? false }, pathname);
    if (hit) return rule;
  }
  return NOT_FOUND_RULE;
}
